import { formats } from '@comall-backend-builder/types';
import { isNil, isNaN } from 'lodash';

export class PageColorPickerFormat extends formats.ObjectFormat {
    /**
     * 对数据进行校验
     */
    validate(rule: any, value: any, callback: any) {
        callback();
    }

    /**
     * 对数据进行格式化
     */
    format(value: any) {
        if (isNil(value) || isNaN(value)) {
            return value.toString();
        } else {
            return '';
        }
    }

    /**
     * 将数据格式化为请求参数
     */
    formatParams(key: any, value: any) {
        return { [key]: value };
    }
}
